<div class="grid tour-dialog">
	<!--Close icon-->
	<icon
		type="times"
		class="pull-right class-hover close"
		(click)="onClose()"
		custom-tracking
		[track-event]="'tour-dialog ' + featureName?.toLowerCase() + ':button:close'"
	></icon>
	<div class="row padding-left-32 body">
		<!--Left side of the modal-body that contains icon,title,description-->
		<div class="col-8 col-md-8 col-sm-24 text-container">
			<div class="icon margin-bottom-8" [innerHTML]="tourDialogContent[stepIndex]?.icon"></div>
			<p class="title text-24-bold margin-bottom-8">{{ tourDialogContent[stepIndex]?.title }}</p>
			<p class="text-14 description">{{ tourDialogContent[stepIndex]?.description }}</p>
		</div>
		<div class="image-container col-16 col-md-16 col-sm-24">
			<div *ngIf="tourDialogContent[stepIndex]?.video; else image">
				<cwp-video-player [videoId]="tourDialogContent[stepIndex]?.video"></cwp-video-player>
			</div>
			<ng-template #image>
				<div [innerHTML]="tourDialogContent[stepIndex]?.image"></div>
			</ng-template>
		</div>
	</div>
	<!--Modal footer-->
	<div class="row footer padding-vertical-24 padding-horizontal-32">
		<!--Represents the dots in the footer and will only be visible when there are more than 1 step-->
		<div class="col-12 col-md-12 col-sm-24 footer-dots">
			<ng-container *ngFor="let content of tourDialogContent; index as iconIndex">
				<ng-container *ngIf="tourDialogContent.length > 1">
					<icon [ngClass]="{ active: iconIndex === stepIndex }" type="circle" class="margin-right-8"></icon>
				</ng-container>
			</ng-container>
		</div>
		<!--Represent the action buttons-->
		<div class="col-12 col-md-12 col-sm-24">
			<!--Button order is from right to left-->
			<button
				*ngIf="stepIndex === tourDialogContent.length - 1"
				(click)="onClose(true)"
				type="button"
				dz-button
				class="pull-right btn btn-header margin-left-24"
				custom-tracking
				[track-event]="'tour-dialog' + featureName?.toLowerCase() + ':step' + (stepIndex + 1) + ':button:final step'"
				[dcrHTMLKey]="featureName + '_STEP_BUTTON_DONE'"
			>
				<span>{{ stepButtonText[2] }}</span>
			</button>
			<button
				*ngIf="stepIndex < tourDialogContent.length - 1"
				(click)="stepIndex = stepIndex + 1"
				type="button"
				dz-button
				class="pull-right btn btn-header margin-left-24"
				custom-tracking
				[track-event]="'tour-dialog ' + featureName?.toLowerCase() + ':step' + (stepIndex + 1) + ':button:next'"
				[dcrHTMLKey]="featureName + '_STEP_BUTTON_NEXT'"
			>
				<span>{{ stepButtonText[1] }}</span>
			</button>
			<button
				*ngIf="stepIndex > 0"
				custom-tracking
				[track-event]="'tour-dialog ' + featureName?.toLowerCase() + ':step' + (stepIndex + 1) + ':button:back'"
				(click)="stepIndex = stepIndex - 1"
				type="button"
				dz-button
				color="secondary"
				class="pull-right back-button"
				[dcrHTMLKey]="featureName + '_STEP_BUTTON_BACK'"
			>
				<span>{{ stepButtonText[0] }}</span>
			</button>
		</div>
	</div>
</div>
